import { Component, Input } from '@angular/core';

export type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg';
export type SpinnerPosition = 'inline' | 'left' | 'right';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  standalone: false
})
export class LoadingSpinnerComponent {
  @Input() size: SpinnerSize = 'md';
  @Input() overlay = false;
  @Input() message?: string;
  @Input() position: SpinnerPosition = 'inline';
  @Input() light = false;

  get spinnerClasses(): string {
    const classes = [`spinner`, `spinner-${this.size}`, 'button_spinner'];

    if (this.position === 'left') {
      classes.push('input-loading-spinner-left');
    } else if (this.position === 'right') {
      classes.push('input-loading-spinner-right');
    }

    if (this.light) {
      classes.push('light-spinner');
    }

    return classes.join(' ');
  }
}
